/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Payment_Method_CashInputs */

const vi_tea_purchase_payment_method_cash = /** @type {(inputs: Tea_Purchase_Payment_Method_CashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền mặt`)
};

/**

* @param {Tea_Purchase_Payment_Method_CashInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_payment_method_cash = /** @type {((inputs?: Tea_Purchase_Payment_Method_CashInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Payment_Method_CashInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_payment_method_cash(inputs)
});